import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["buttons"]
  static values = {
    product: String
  }

  select(event) {
    const target = event.currentTarget
    const price = target.dataset.metalSelectorPrice
    const variantLink = target.dataset.metalSelectorVariant
    const productId = target.dataset.metalSelectorProduct

    // Update price display
    const priceElement = document.querySelector(`.variant-price-${productId}`)
    if (priceElement) {
      priceElement.textContent = price
    }

    // Update variant links
    document.querySelectorAll(`.variant-link-${productId}`).forEach(link => {
      link.href = variantLink
      link.title = `Starting Price ${price}`
      link.setAttribute('aria-label', `Starting Price ${price}`)
      if (!link.dataset.turboFrame) {
        link.dataset.turboFrame = '_top'
      }
    })

    // Update metal selection visual state
    this.buttonsTarget.querySelectorAll('button').forEach(btn => {
      btn.classList.remove('active')
    })
    target.classList.add('active')
  }
}
